/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboStockManagementBadRequestResponse,
  BboStockManagementFailureResponseResponse,
  BboStockManagementForbiddenResponse,
  BboStockManagementNoContentResponse,
  BboStockManagementUnauthorizedResponse,
  GetProductListForCountTypeParams,
  StockItem,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get product details for count type
 * @summary this endpoint is used to get the product details at particular accounting location based on count type
 */
export const getProductListForCountType = (
  params?: GetProductListForCountTypeParams,
  signal?: AbortSignal,
) => {
  return customInstance<StockItem | BboStockManagementNoContentResponse>({
    url: `/bm-stock-management-service/v1/product-list`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetProductListForCountTypeQueryKey = (
  params?: GetProductListForCountTypeParams,
) => {
  return [`/bm-stock-management-service/v1/product-list`, ...(params ? [params] : [])] as const;
};

export const getGetProductListForCountTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof getProductListForCountType>>,
  TError = ErrorType<
    | BboStockManagementBadRequestResponse
    | BboStockManagementUnauthorizedResponse
    | BboStockManagementForbiddenResponse
    | BboStockManagementFailureResponseResponse
  >,
>(
  params?: GetProductListForCountTypeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductListForCountType>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProductListForCountTypeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductListForCountType>>> = ({
    signal,
  }) => getProductListForCountType(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getProductListForCountType>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProductListForCountTypeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProductListForCountType>>
>;
export type GetProductListForCountTypeQueryError = ErrorType<
  | BboStockManagementBadRequestResponse
  | BboStockManagementUnauthorizedResponse
  | BboStockManagementForbiddenResponse
  | BboStockManagementFailureResponseResponse
>;

/**
 * @summary this endpoint is used to get the product details at particular accounting location based on count type
 */
export const useGetProductListForCountType = <
  TData = Awaited<ReturnType<typeof getProductListForCountType>>,
  TError = ErrorType<
    | BboStockManagementBadRequestResponse
    | BboStockManagementUnauthorizedResponse
    | BboStockManagementForbiddenResponse
    | BboStockManagementFailureResponseResponse
  >,
>(
  params?: GetProductListForCountTypeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getProductListForCountType>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetProductListForCountTypeQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
